import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RecruitmentDto } from './recruitment-dto';

export class RecruitmentResponseModel extends GlobalResponseObject {
    data?: RecruitmentDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //RecruitmentDto
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: RecruitmentDto) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
